import React from "react";
import src from "../../assets/imagesOld/logo1.png";
import { connect } from "react-redux";
import actionWays from "../../redux/actions";
import { withRouter } from "react-router-dom";
import { developingMessage } from "../../utils/msg";
import { JumpApply } from "../Jump";
import "./common.scss";
import { message, Image } from "antd";
import { NavLink } from "react-router-dom";
import { withTranslation } from "react-i18next";
import changeLanguage1 from "../../assets/images/changeLanguage1.png";
import changeLanguage2 from "../../assets/images/changeLanguage2.png";
class Top extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      needFixed: false,
      currentIndex: this.props.thirdIndex || 0,
      currentLink: "",
      loginLoading: false,
      drawerVisible: false,
      showChanPin: false,
      showGuanYu: false,
      src: src,
      showSolution: false,
      activeItem: null,
      currentPath: this.props.location.pathname, // 初始化路径
    };
    this.unlisten = null;
    this.timers = null;
    this.solutionRef = React.createRef();
    this.language = localStorage.getItem("i18nextLng") || "zh";
    this.homeTop = this.getNavigation();
    this.specialIndex = [
      {
        index: 1,
        paths: ["/solution/KernelModulePage"],
      },
      {
        index: 5,
        paths: ["/apply"],
      },
    ]; // 记录特殊路径的索引
  }
  // dispatch = useDispatch()
  componentDidMount() {
    this.getNavigation();
    this.getActive();
    // 判断点击产品服务之外的地方，关闭产品服务下拉
    this.handleClickOutside = (e) => {
      if (
        this.solutionRef.current &&
        !this.solutionRef.current.contains(e.target)
      ) {
        this.setState({
          showSolution: false,
          // activeItem: null,
        });
      }
    };
    // document.addEventListener("click", this.handleClickOutside);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentIndex !== this.state.currentIndex) {
      console.log("currentIndex 已更新:", this.state.currentIndex);
    }
  }

  // componentWillUnmount() {
  //   // 清除监听
  //   if (this.unlisten) this.unlisten();
  // }
  getNavigation = () => {
    const { t } = this.props;
    return [
      { name: t("navigation.home"), links: "/home", children: [] },
      {
        name: t("navigation.product"),
        links: "/solution",
        children: [
          { links: "/solution/archives", name: t("navigation.product1") },
          { links: "/solution/infoServices", name: t("navigation.product2") },
          { links: "/solution/asset", name: t("navigation.product3") },
          {
            links: "/solution/spaceOperations",
            name: t("navigation.product4"),
          },
          { links: "/solution/residency", name: t("navigation.product5") },
        ],
      },
      { name: t("navigation.success"), links: "/successStories", children: [] },
      { name: t("navigation.about"), links: "/aboutUs", children: [] },
    ];
  };
  getActive() {
    const result = this.specialIndex.filter((item) =>
      item.paths.includes(this.props.location.pathname)
    );
    if (result.length) {
      this.setState({ currentIndex: result[0].index});
      return;
    }
    for (let i in this.homeTop) {
      // 第一级
      if (this.homeTop[i].links === this.props.location.pathname) {
        this.setState({
          currentIndex: i,
          currentLink: this.props.location.pathname,
        });
        return;
      }
      // 第二级/第三级
      for (let j in this.homeTop[i].children) {
        if (
          (this.homeTop[i].children[j].links &&
            this.homeTop[i].children[j].links ===
              this.props.location.pathname) ||
          (this.homeTop[i].children[j].children?.length &&
            this.homeTop[i].children[j].children?.findIndex(
              (x) => x.links === this.props.location.pathname
            ) !== -1)
        ) {
          this.setState({
            currentIndex: i,
            currentLink: this.props.location.pathname,
          });
        }
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname) {
      console.log(this.props.location.pathname,"当期路径是");
    }
  }
  componentWillUnmount() {
    clearInterval(this.timers);
    this.setState = () => false;
    document.removeEventListener("click", this.handleClickOutside);
  }
  elect = async (index, item) => {
    console.log("item1", item.links);

    if (item.links != "/solution") {
      this.props.history.push({ pathname: item.links, query: {} });
    }
    if (!item.links) {
      this.setState({
        showSolution: false,
      });
      developingMessage();
    }
  };
  mouseLeave = () => {
    this.setState({
      showChanPin: false,
      showGuanYu: false,
    });
  };

  changeIndex = (currentIndex, index) => {
    console.log(currentIndex, index, "currentIndex");
    return currentIndex == index ? "elect" : "";
  };
  changeLink = (currentLink, link) => {
    return (currentLink == link || currentLink.indexOf(link) !== -1) && link
      ? "elect"
      : "";
  };
  mouseEnter = (index, item) => {
    console.log("item", item);

    if (item.links == "/solution") {
      this.setState({
        showSolution: true,
        activeItem: item,
      });
    } else {
      this.setState({
        showSolution: false,
      });
    }
  };
  tableBody = (item, index) => {
    const { currentIndex } = this.state;
    return (
      <div className="fixNavView_con_body" key={index}>
        <a
          className={this.changeIndex(currentIndex, index)}
          onClick={() => {
            if(!item.children.length){
              this.elect(index, item);
            }
            this.mouseEnter(index, item);
          }}
          onMouseEnter={() => {
            this.mouseEnter(index, item);
          }}
        >
          {item.name}
        </a>
      </div>
    );
  };

  onClose = () => {
    this.setState({
      drawerVisible: false,
    });
  };
  changeLanguage = (lang) => {
    const { i18n } = this.props;
    i18n.changeLanguage(lang);
    window.location.reload();
  };
  render() {
    const { showSolution, src, activeItem, drawerVisible, loginLoading } =
      this.state;
    return (
      <>
        <div
          id="topId"
          className={"fixNavViews"}
          style={{ minWidth: "1300px" }}
        >
          <div id="topContentId" className="fixNavView_con">
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                width: "1400px",
                margin: "auto",
              }}
            >
              <div className="fixNavView_con_logo">
                <a
                  onClick={() => {
                    this.props.history.push({ pathname: "/home" });
                  }}
                >
                  <img
                    style={{ height: "30px", margin: "0 10px" }}
                    src={require("../../assets/images/logo.png").default}
                  />
                  <img
                    style={{ height: "30px" }}
                    src={require("../../assets/images/name.png").default}
                  />
                </a>
              </div>
              <>{this.homeTop?.map(this.tableBody)}</>
              {this.language == "zh" ? (
                <div
                  className="fixNavView_con_language"
                  onClick={() => {
                    this.changeLanguage("en");
                  }}
                >
                  <img src={changeLanguage1} />
                </div>
              ) : (
                <div
                  className="fixNavView_con_language"
                  onClick={() => {
                    this.changeLanguage("zh");
                  }}
                >
                  <img src={changeLanguage2} />
                </div>
              )}

              <div className="fixNavView_con_number">
                <img
                  src={
                    require("../../assets/imagesOld/common/dianhua.png").default
                  }
                />
                021-57186429
              </div>
              <div className="fixNavView_con_btn">
                <JumpApply />
              </div>
            </div>
            {showSolution ? (
              <div
                ref={this.solutionRef}
                className="navsolution-container"
                // onMouseLeave={() => {
                //   this.setState({
                //     showSolution: false,
                //     activeItem: null,
                //   });
                // }}
              >
                <ul className="navsolution-container-right">
                  {activeItem.children.map((item, index) => {
                    const { currentLink } = this.state;
                    return (
                      <li key={index}>
                        {/* className={this.changeLink(currentLink, item.links)} */}
                        <a
                          onClick={() => {
                            this.elect(index, item);
                          }}
                          style={this.language === "zh"?{fontSize: ''}:{fontSize: '14px'}}
                        >
                          {item.name}
                        </a>
                        <div style={{display: this.state.currentPath === item.links ? 'block' : 'none'}} className="navsolution-container-right-line"></div>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(Top)));
